<!-- 设置公共页面，仅做跳转使用 -->
<template>
  <div class="table-box">
    <!-- table 组件 -->
    <Table
      v-loading="loading"
      :data="tableData"
      :tableHeight="585"
      :columns="columns"
      :operation="dateOperation"
      ref="tanleAssembly"
      @getList="getList"
      @operate="operationEvent"
      :currentPage="currentPage"
      :pageSize="pageSize"
      :operationWidth="120"
      @sortChange="handleSort"
    ></Table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalData"
    >
    </el-pagination>
    <!--新增、编辑设备窗口-->
    <el-dialog
      :title="editDevice ? $t('edit') + $t('controlCabinet') : $t('newlyAded') + $t('controlCabinet')"
      :visible.sync="deviceVisible"
      :append-to-body="true"
      width="830px"
      :close-on-click-modal="false"
      :before-close="cancel"
    >
      <div class="common-blue-contain">
        <el-form :model="controlForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="14">
              <el-form-item :label="$t('serialNumberP2')" :label-width="formLabelWidth" :required="true">
                <el-input
                  v-model="controlForm.serialNumber"
                  autocomplete="off"
                  :placeholder="$t('pleaseEnter') + $t('serialNumberP2')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item :label="$t('nameC')" :label-width="formLabelWidth" :required="true">
                <el-input
                  v-model="controlForm.cabinetName"
                  autocomplete="off"
                  :placeholder="$t('pleaseEnter') + $t('nameC')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="14">
              <el-form-item :label="$t('controlCabinetTotal')" :label-width="formLabelWidth" :required="true">
                <el-input
                  v-model="controlForm.totalCell"
                  autocomplete="off"
                  type="number"
                  @blur="handleAll"
                  :placeholder="$t('pleaseEnter') + $t('controlCabinetTotal')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item :label="$t('mechanism')" :label-width="formLabelWidth" :required="true">
                <el-select
                  ref="ouSelect"
                  v-model="controlForm.ouName"
                  style="width:auto"
                  :placeholder="$t('peaseSelect')"
                  popper-append-to-body
                  @change="changeOu"
                  clearable
                  @visible-change="visibleChange"
                >
                  <el-option :value="controlForm.ouName" style="height:auto;padding:0px">
                    <el-tree
                      ref="ouTree"
                      node-key="id"
                      highlight-current
                      :expand-on-click-node="false"
                      :data="ouList"
                      :props="defaultProps"
                      @node-click="selectOu"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="14">
              <el-form-item :label="$t('controlCabinetChargeCount')" :label-width="formLabelWidth" :required="true">
                <el-input
                  v-model="controlForm.singleFrameCount"
                  autocomplete="off"
                  type="number"
                  max="50"
                  :placeholder="$t('pleaseEnter') + $t('controlCabinetChargeCount')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item :label="$t('state')" :label-width="formLabelWidth" :required="true">
                <el-radio-group v-model="controlForm.cabinetStatus">
                  <el-radio :label="1" value="1">{{ $t('enable') }}</el-radio>
                  <el-radio :label="0" value="0">{{ $t('disable') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="cupboard-list">
            <div
              class="cupboards"
              v-for="(item, index) in controlForm.cells"
              :key="index"
              @click="selectUser(item, index)"
            >
              <span class="cupboardId">{{ index + 1 }}</span>
              <div style="margin-left: 20px;margin-top: 20px;" v-if="item.userBinds && item.userBinds.length > 0">
                <span class="users" v-for="(user, idx) in item.userBinds" :key="user.userName">
                  <span v-show="idx === 0 || idx === 1 || idx === 2"
                    >{{ user.userName }}<i v-show="idx !== item.userBinds.length - 1 && idx !== 2">、</i></span
                  >
                </span>
                <span v-show="item.userBinds.length > 2" style="color: var(--color-grey);">{{ $t('users') }}</span>
              </div>
            </div>
          </el-row>
        </el-form>
      </div>
      <el-dialog
        :title="$t('authorizedUsers')"
        class="common-blue-contain"
        :append-to-body="true"
        :visible.sync="innerVisible"
        width="450px"
        :close-on-click-modal="false"
        :show-close="true"
        @close="innerVisible = false"
      >
        <div id="setRecord">
          <div class="group">
            <el-input
              :placeholder="$t('searchM')"
              v-model="addUsername"
              class="serch-add"
              style="width:100% !important;"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="broad">
            <div>
              <elTree2
                v-show="ListWalkie.length > 0"
                ref="InteruserTree"
                :data="ListWalkie"
                :check-on-click-node="true"
                :default-checked-keys="userCheckedList"
                show-checkbox
                node-key="userId"
                :filter-node-method="filterNode"
                default-expand-all
                :check-strictly="true"
                :props="usertProps"
                key="InteruserTree"
              >
              </elTree2>
            </div>
            <div class="setTree">
              <span v-if="ListWalkie.length <= 0">{{ $t('bindAvailable') }}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editUser">{{ $t('determine') }}</el-button>
          <el-button @click="cancelUpdate">{{ $t('cancel') }}</el-button>
        </span>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFrom()">{{ $t('determine') }}</el-button>
        <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入table组件
import Table from '@/components/table'
import { devicecabinetPage, deleteCabinet, savecabinet, devicecabinetUser } from '@/api/new-device/controlCabinet'
import { findDeviceList } from '@/api/monitor'
import elTree2 from '@/components/vTree/src/tree'
import { errorMessage } from '@/util/common'

export default {
  name: 'controlCabinet',
  components: {
    Table,
    elTree2,
  },
  props: {
    ouList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 当前页
      currentPage: 1,
      // 当前 条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      // table 表头数组
      columns: [],
      // table 操作栏数组
      dateOperation: [],
      // table 数据
      tableData: [],
      // 遮罩层
      loading: false,
      formInline: {},
      // 是否编辑设备窗口
      editDevice: false,
      // 是否显示弹窗
      deviceVisible: false,
      formLabelWidth: '160px',
      ouName: '',
      // 表单
      controlForm: {
        cabinetStatus: 1,
        cells: [],
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      addUsername: '',
      innerVisible: false,
      // 用户列表
      ListWalkie: [],
      // 选择的用户
      userCheckedList: [],
      // 选择的用户下标
      userIndex: null,
      // 柜子数
      cells: null,
      ouPath: '',
    }
  },
  computed: {
    usertProps() {
      return {
        children: 'children',
        label: 'name',
        disabled: (data, node) => {
          // type-判断是否为父节点
          return data && !data.type
        },
      }
    },
  },
  mounted() {
    this.basicConfig()
    this.getList()
  },
  methods: {
    // 选择用户
    selectUser(item, index) {
      this.getUsers()
      this.userIndex = index
      this.innerVisible = true
      this.userCheckedList = []
      if (item && item.userBinds) {
        for (let i of item.userBinds) {
          this.userCheckedList.push(i.userId)
        }
      }
      this.$nextTick(() => {
        this.$refs.InteruserTree.setCheckedKeys(this.userCheckedList)
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 选择用户后
    editUser() {
      let userCheckedList = []
      this.$refs.InteruserTree.getCheckedNodes().forEach(item => {
        userCheckedList.push({ userId: item.userId, userName: item.name })
      })
      if (userCheckedList.length > this.controlForm.singleFrameCount) {
        errorMessage(this.$t('numberSelectedUsers'))
        return
      }
      this.userCheckedList = userCheckedList
      this.$set(this.controlForm.cells[this.userIndex], 'userBinds', userCheckedList)

      this.innerVisible = false
    },
    cancelUpdate() {
      this.innerVisible = false
    },
    // 获取用户
    getUsers() {
      let param = { ouId: this.controlForm.ouId }
      devicecabinetUser(param).then(res => {
        if (res.state === 0) {
          this.ListWalkie = res.data
        }
      })
    },
    // 写入柜数后，生成柜子
    handleAll(val) {
      if (Number(this.controlForm.totalCell) > Number(this.cells)) {
        let length = this.controlForm.totalCell - this.cells
        this.handleData(length)
        this.cells = Number(this.controlForm.totalCell)
      } else if (this.controlForm.totalCell < this.cells) {
        let length = this.cells - this.controlForm.totalCell
        // 获取要删除的数据
        let spliceData = this.controlForm.cells.slice(this.controlForm.totalCell)
        // 判断是否存在绑定用户
        let hasBind = spliceData.some(item => {
          if (item.userBinds.length > 0) {
            errorMessage(this.$t('alreadyExists'))
            return true
          }
        })
        // 删除数据
        if (!hasBind) {
          this.controlForm.cells.splice(this.controlForm.totalCell, length)
          this.cells = Number(this.controlForm.totalCell)
        }
      }
    },
    handleData(data) {
      let length = this.controlForm.cells.length
      for (let i = 0; i < data; i++) {
        let index = i + +1 + length
        this.controlForm.cells.push({
          identifier: index,
          userBinds: [],
        })
      }
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 选中机构，过滤用户
    selectOu(data) {
      this.$set(this.controlForm, 'ouName', data.name)
      this.controlForm.ouId = data.id
      this.$refs.ouSelect.blur()
      // 如果在旧的path中找到新的path，说明新选的机构是旧机构的上级机构，不用清空，其他情况清空
      if (!this.ouPath.includes(data.path)) {
        this.controlForm.cells.map(item => {
          item.userBinds = []
        })
      }
      this.ouPath = data.path
      this.getUsers()
    },
    changeOu(data) {
      if (!data) {
        this.$nextTick(() => {
          this.$refs.ouTree.setCurrentKey(null)
        })
      }
    },
    cancel() {
      this.deviceVisible = false
      this.$refs.ouTree.setCurrentKey(null)
      this.controlForm = {
        cabinetStatus: 1,
        cells: [],
      }
    },
    // 新增设备
    addDevice() {
      this.controlForm = {
        cabinetStatus: 1,
        cells: [],
      }
      this.editDevice = false
      this.deviceVisible = true
      this.controlForm.ouId = this.ouList[0].id
      this.cells = 0
    },
    submitFrom() {
      if (!this.controlForm.serialNumber) {
        errorMessage(this.$t('pleaseEnter') + this.$t('serialNumberP'))
        return
      }
      if (!this.controlForm.cabinetName) {
        errorMessage(this.$t('pleaseEnter') + this.$t('nameC'))
        return
      }
      if (!this.controlForm.totalCell) {
        errorMessage(this.$t('pleaseEnter') + this.$t('controlCabinetTotal'))
        return
      }
      if (this.controlForm.totalCell+'' === '0') {
        errorMessage(this.$t('totalCannotBe0'))
        return
      }
      if (!this.controlForm.ouName) {
        errorMessage(this.$t('peaseSelect'))
        return
      }
      console.log(this.controlForm.singleFrameCount)
      if (this.controlForm.singleFrameCount === '' || this.controlForm.singleFrameCount === undefined) {
        errorMessage(this.$t('pleaseEnter') + this.$t('controlCabinetChargeCount'))
        return
      }
      this.controlForm.singleFrameCount = Number(this.controlForm.singleFrameCount)
      this.controlForm.totalCell = Number(this.controlForm.totalCell)
      savecabinet(this.controlForm).then(res => {
        if (res.state === 0) {
          if (this.controlForm.id) {
            this.$message({
              type: 'success',
              message: this.$t('EditSucceeded'),
            })
          } else {
            this.$message({
              type: 'success',
              message: this.$t('AddSuccess'),
            })
          }
          this.deviceVisible = false
          this.currentPage = 1
          this.getList()
        }
      })
    },

    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._delectInfo(row)
      } else if (row.type === 'edit') {
        this._editInfo(row)
      }
    },
    // 编辑
    _editInfo(row) {
      this.editDevice = true
      this.deviceVisible = true
      this.controlForm = JSON.parse(JSON.stringify(row.value))
      this.cells = this.controlForm.totalCell
      this.getUsers()
    },
    // 删除
    _delectInfo(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      })
        .then(() => {
          deleteCabinet({ id: row.value.id }).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.getList()
            }
          })
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 查询
    getList(data) {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      if (data) {
        param = Object.assign(param, data)
      }
      devicecabinetPage(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          res.data.list.forEach(item => {
            item.status = item.cabinetStatus === 1 ? this.$t('enable') : this.$t('disable')
          })
          this.tableData = res.data.list
          this.totalData = res.data.total
        }
      })
    },
    basicConfig() {
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'serialNumber',
          label: this.$t('serialNumberP'),
          sort: 'serialNumber',
        },
        {
          attrName: 'cabinetName',
          label: this.$t('nameC'),
          sort: 'cabinetName',
        },
        {
          attrName: 'totalCell',
          label: this.$t('controlCabinetTotal'),
          align: 'right',
          width: '160',
          sort: 'totalCell',
        },
        {
          attrName: 'singleFrameCount',
          label: this.$t('controlCabinetChargeCount'),
          align: 'right',
          width: '200',
          sort: 'singleFrameCount',
        },
        {
          attrName: 'status',
          label: this.$t('state'),
          align: 'center',
          width: '140',
          sort: 'cabinetStatus',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: this.$t('edit'),
          icon: '',
          type: 'edit',
          class: 'editClick',
          IsHad: '',
        },
        {
          operateName: this.$t('delete'),
          icon: '',
          type: 'delect',
          class: 'editClick',
          IsHad: '',
        },
      ]
    },
  },
  watch: {
    addUsername(val) {
      this.$refs.InteruserTree.filter(val)
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.cupboard-list
  max-height 430px
  overflow auto
::-webkit-scrollbar
  width 3px
  height 3px
.cupboards
  position: relative
  width: 125px;/*no*/
  height: 80px;/*no*/
  float: left
  border: 1px solid var(--border-grey)
  cursor pointer
  .cupboardId
    position: absolute
    top 5px
    left 5px
    font-size: 16px
    font-weight: 600
    line-height: 22px
    color: #222
  .users
    color: var(--color-grey);
    span
      margin-right: 5px
.el-tree
  background-color: var(--new-input-bg);
>>>.el-tree-node__content
  color: var(--new-el-select-dropdown-item);

#setRecord
  .broad
    .el-tree
      height 300px
      overflow auto
>>>.el-checkbox.is-disabled
  display none
.theme-dark
  .cupboards
    .cupboardId
      color: #fff
</style>
